import React from "react"
import FieldProto from "../../../../proto/field-proto";
import {ItemIconClass} from "../../../../../gd/const/item-icon/icon/item-icon-class";
import {ItemIconSize} from "../../../../../gd-components/icons/@const";
import CustomIcon from "../../../../../gd-components/icons/common/custom-icon/custom-icon";
import {EmojiDict} from "../../../../../gd/const/item-icon/emoji/emoji";
import Emoji from "../../../../../gd-components/icons/common/emoji/emoji";

type Props = {
    className   : string
    field       : FieldProto
    value       : string
    disabled?   : boolean
    size?       : ItemIconSize
    children    : any

    onClick     : callback
}

export default function FieldIcon_FormValueNotEmpty(props: Props) {

    const iconSize = props.size ? props.size : ItemIconSize.SIZE_14

    const classes = Classes("ui5-field-form-editable", "dropdown-form",  "h-36", props.className, {
        "disabled": props.disabled,
    })

    const renderIcon = ()=> {

        if (props.value?.substring(0, 4) === 'url:') {
            return <CustomIcon size={iconSize} className={props.className} icon={props.value}/>
        }

        if (!!EmojiDict[props.value]) {

            // need add black and white fiulter when disabled ?
            const classes = Classes(props.className)

            return <Emoji name={props.value} className={classes} size={iconSize}/>
        }

        const iconClass = ItemIconClass[props.value]

        const iconClasses = Classes(iconClass, "ui5-ico-"+iconSize)

        return <div className={iconClasses}></div>
    }

    return (
        <>
            <div className={classes} onClick={props.onClick}>
                {renderIcon()}
            </div>
            {props.children}
        </>
    )
}
